import { render, staticRenderFns } from "./DCIRegistration.vue?vue&type=template&id=7f93bcf0&scoped=true"
import script from "./DCIRegistration.vue?vue&type=script&lang=js"
export * from "./DCIRegistration.vue?vue&type=script&lang=js"
import style0 from "./DCIRegistration.vue?vue&type=style&index=0&id=7f93bcf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f93bcf0",
  null
  
)

export default component.exports